export const title = [
    {
        title: '選手名'
    },
    {
        title: '選手名'
    },
    {
        title: '防御率'
    },
    {
        title: '投球回'
    },
    {
        title: '投球数'
    },
    {
        title: '打者'
    },
    {
        title: '被安打'
    },
    {
        title: '被本塁打'
    },
    {
        title: '奪三振'
    },
    {
        title: '与四球'
    },
    {
        title: '与死球'
    },
    {
        title: '失点*'
    },
    {
        title: '自責点*'
    },

]
export const tableTitle2 = [
    {
        code: 1,
        title: 'ポジション | 選手名'
    },
    {
        code: 2,
        title: 'ポジション | 選手名'
    },
    {
        code: 1,
        title: '投',
        title1:'打'
    },
    {
        code: 1,
        title: '防御率',
        title1: '打率'
    },
]

export const tableTitleStartingPitcher = [
    {
        title: '投手'
    },
    {
        title: 'ポジション | 選手名'
    },
    {
        title: '投'
    },
    {
        title: '防御率'
    },
]

export const tableTitleStartingBatter = [
    {
        title: '打順'
    },
    {
        title: 'ポジション | 選手名'
    },
    {
        title: '打'
    },
    {
        title: '打率'
    },
]
